import {ApiError} from './exceptions'
import * as statusCodes from './api/statusCodes'

export const BELOW_EVENT_DATE_HTO_CUTOFF = 'BELOW_EVENT_DATE_HTO_CUTOFF'
export const BELOW_HTO_ARRIVAL_DATE_CUTOFF = 'BELOW_HTO_ARRIVAL_DATE_CUTOFF'
export const EMPTY_ASSIGNED_LOOKS = 'EMPTY_ASSIGNED_LOOKS'
export const EVENT_DATE_TOO_SOON = 'EVENT_DATE_TOO_SOON'
export const NO_EVENT = 'NO_EVENT'
export const NO_EVENT_DATE = 'NO_EVENT_DATE'
export const NO_HTO_ARRIVAL_DATE = 'NO_HTO_ARRIVAL_DATE'
export const NO_PRODUCTS = 'NO_PRODUCTS'
export const NO_PRODUCTS_IN_HTO = 'NO_PRODUCTS_IN_HTO'
export const NO_SIZES = 'NO_SIZES'
export const NO_USER = 'NO_USER'
export const ORDER_COMPLETED = 'ORDER_COMPLETED'
export const PAST_EVENT_DATE = 'PAST_EVENT_DATE'
export const PRODUCTS_UNAVAILABLE_FOR_GROUP = 'PRODUCTS_UNAVAILABLE_FOR_GROUP'
export const RETIRED_PRODUCTS = 'RETIRED_PRODUCTS'
export const SIZES_NOT_CARRIED_FOR_PRODUCTS = 'SIZES_NOT_CARRIED_FOR_PRODUCTS'
export const SOLD_OUT_PRODUCTS = 'SOLD_OUT_PRODUCTS'
export const SOLD_OUT_PRODUCTS_IN_HTO = 'SOLD_OUT_PRODUCTS_IN_HTO'
export const SOLD_OUT_SKUS_FOR_PRODUCTS = 'SOLD_OUT_SKUS_FOR_PRODUCTS'
export const UNABLE_TO_PROCESS_CREDIT_CARD_FRAUD = 'UNABLE_TO_PROCESS_CREDIT_CARD_FRAUD'
export const UNABLE_TO_PROCESS_CREDIT_CARD = 'UNABLE_TO_PROCESS_CREDIT_CARD'
export const INCORRECT_BILLING_ADDRESS = 'INCORRECT_BILLING_ADDRESS'
export const UNASSIGNED_LOOKS = 'UNASSIGNED_LOOKS'
export const MISSING_SHIPPING_ADDRESS = 'MISSING_SHIPPING_ADDRESS'
export const MISSING_BILLING_ADDRESS = 'MISSING_BILLING_ADDRESS'
export const MISSING_REQUIRED_FIELDS = 'MISSING_REQUIRED_FIELDS'

export const UNAUTHORIZED = 'UNAUTHORIZED'
export const NOT_FOUND = 'NOT_FOUND'
export const CONFLICT = 'CONFLICT'
export const SERVER_ERROR = 'SERVER_ERROR'

export const errorStatusMapping = {
  [statusCodes.UNAUTHORIZED]: UNAUTHORIZED,
  [statusCodes.NOT_FOUND]: NOT_FOUND,
  [statusCodes.CONFLICT]: CONFLICT,
  // no distinction is made between server errors for our purpose
  [statusCodes.SERVER_ERROR]: SERVER_ERROR,
  [statusCodes.BAD_GATEWAY]: SERVER_ERROR,
}

export const PRECHECKOUT_VALIDATION = 'GET_PRECHECKOUT_VALIDATION'
export const PRECHECKOUT_VALIDATION_UNAUTHORIZED = `${PRECHECKOUT_VALIDATION}_${UNAUTHORIZED}`
export const PRECHECKOUT_VALIDATION_NOT_FOUND = `${PRECHECKOUT_VALIDATION}_${NOT_FOUND}`
export const PRECHECKOUT_VALIDATION_SERVER_ERROR = `${PRECHECKOUT_VALIDATION}_${SERVER_ERROR}`

export const GET_SHIPPING = 'GET_SHIPPING_ADDRESS'
export const GET_SHIPPING_UNAUTHORIZED = `${GET_SHIPPING}_${UNAUTHORIZED}`
export const GET_SHIPPING_NOT_FOUND = `${GET_SHIPPING}_${NOT_FOUND}`
export const GET_SHIPPING_SERVER_ERROR = `${GET_SHIPPING}_${SERVER_ERROR}`

export const GET_SUMMARY = 'GET_ORDER_SUMMARY'
export const GET_SUMMARY_UNAUTHORIZED = `${GET_SUMMARY}_${UNAUTHORIZED}`
export const GET_SUMMARY_NOT_FOUND = `${GET_SUMMARY}_${NOT_FOUND}`
export const GET_SUMMARY_SERVER_ERROR = `${GET_SUMMARY}_${SERVER_ERROR}`

export const SAVE_SHIPPING = 'SAVE_SHIPPING_ADDRESS'
export const SAVE_SHIPPING_UNAUTHORIZED = `${SAVE_SHIPPING}_${UNAUTHORIZED}`
export const SAVE_SHIPPING_NOT_FOUND = `${SAVE_SHIPPING}_${NOT_FOUND}`
export const SAVE_SHIPPING_SERVER_ERROR = `${SAVE_SHIPPING}_${SERVER_ERROR}`

export const SAVE_PARTNER = 'SAVE_PARTNER_INFO'
export const SAVE_PARTNER_SERVER_ERROR = `${SAVE_PARTNER}_${SERVER_ERROR}`

export const SAVE_BILLING = 'SAVE_BILLING_ADDRESS'
export const SAVE_BILLING_UNAUTHORIZED = `${SAVE_BILLING}_${UNAUTHORIZED}`
export const SAVE_BILLING_NOT_FOUND = `${SAVE_BILLING}_${NOT_FOUND}`
export const SAVE_BILLING_SERVER_ERROR = `${SAVE_BILLING}_${SERVER_ERROR}`

export const PROCESS_CHECKOUT = 'PROCESS_CHECKOUT'
export const PROCESS_CHECKOUT_UNAUTHORIZED = `${PROCESS_CHECKOUT}_${UNAUTHORIZED}`
export const PROCESS_CHECKOUT_NOT_FOUND = `${PROCESS_CHECKOUT}_${NOT_FOUND}`
export const PROCESS_CHECKOUT_SERVER_ERROR = `${PROCESS_CHECKOUT}_${SERVER_ERROR}`
export const PROCESS_CHECKOUT_CONFLICT = `${PROCESS_CHECKOUT}_${CONFLICT}`

// These errors should fail silently and not alter the checkout page
export const benignErrors = [GET_SHIPPING_SERVER_ERROR]

export const getStatusType = (status) => {
  if (errorStatusMapping[status]) {
    return errorStatusMapping[status]
  }
  throw new Error(`Unsupported status code: ${status}`)
}

// Returns the specific api error encountered by the checkout page
// eg: GET_SHIPPING_ADDRESS_UNAUTHORIZED
export const checkoutApiError = (apiName, status) => {
  let statusType
  try {
    statusType = getStatusType(status)
  } catch (e) {
    statusType = SERVER_ERROR // if unsupported status code, default to server error
  }
  return new ApiError(`${apiName}_${statusType}`)
}
